import { IStorageFilesStore } from './types';

const initStore: IStorageFilesStore = {
  items: [],
  pagination: {
    page: 0,
    itemsPerPage: 20,
    hasMore: false,
  },
};

export default initStore;
